import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-benefit-box',
  templateUrl: './benefit-box.component.html',
  styleUrls: ['./benefit-box.component.scss'],
})
export class BenefitBoxComponent implements OnInit, OnChanges {
  @Input() item: any = {};
  @Input() redeemCodes: boolean;
  @Input() days: string = '';
  @Input() isBenefitPage: boolean;  
  @Input() bothTypes: boolean = false;
  showBothTypesClass: boolean = false;
  weekDays = [
    { label: 'D', value: 7 },
    { label: 'L', value: 1 },
    { label: 'M', value: 2 },
    { label: 'M', value: 3 },
    { label: 'J', value: 4 },
    { label: 'V', value: 5 },
    { label: 'S', value: 6 },
  ];
  activeDays: number[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bothTypes'] && changes['bothTypes'].currentValue === true) {
      this.showBothTypesClass = true;
    }
  }
  ngOnInit(): void {
    this.activeDays = this.item.days.split('').map(Number);
    if (this.bothTypes) {
      this.showBothTypesClass = true;
    }
  }

  get isMobileOrBenefitPage(): boolean {
    return this.isBenefitPage && window.innerWidth <= 1000;
  }

  getDiscountLimit(itemName: string): string[] {
    const discountLimits: { [key: string]: string[] } = {
      '365-20': [
        'Tope de reintegro $6.000 por usuario por mes'
      ],
      '365-10': [
        'Tope de reintegro $4.000 por usuario por semana'
      ],
      'personal-pay-20' : [
        'Tope de reintegro de hasta $5.000'
      ],
      'bna-modo-25-de-descuento': [
        'Tope de reintegro $20.000 por cliente.'
      ],
      'bna-12-cuotas': [
        '12 CSI lubricantes'
      ],  
      'jumbo-15-lub': [
        'Tope de reintegro $4.000'
      ],
      'galicia10 ': [
        'Tope de reintegro $10.000'
      ],
      'prex-20':[
        'Tope de reintegro $4.000 por usuario'
      ],
      'eminent15': [
        'Tope de reintegro $15.000'
      ],
      'galiciamaspremium15': [
        'Tope de reintegro $15.000'
      ],
      'galiciamas10': [
        'Tope de reintegro $10.000'
      ],
      'bnamodo-25': [
        'Tope $20.000 por cliente'
      ],
      'jumbo15lubricantes': [
        'Tope $4.000'
      ],
      'jumbo-vea-10': [
        '+5% extra Tope de reintegro $4.000'
      ],
      'club-easy-10': [
        'Tope de descuento $3.000'
      ],
    };
  
    return discountLimits[itemName] || [];
  }

  getBenefitCategoryName(itemName: string): string {
    const lubricantes = ['jumbo-15','bna12', 'jumbo15lubricantes', '365-20'];
    const fuel = ['bnamodo-25'];
    const shellSelect = [''];
    const shellVPower = ['ripio-5', 'prex-20', '365-10', 'jumbo-vea-10', 'club-easy-10'];
    const allProducts = [''];
    const lubricantesFuel = ['galicia10', 'eminent15', 'galiciamas10', 'galiciamaspremium15', 'personal-pay-20'];
  
    if (lubricantes.includes(itemName)) {
      return 'Lubricantes';
    } else if (shellSelect.includes(itemName)) {
      return 'Shell Select';
    } else if (shellVPower.includes(itemName)) {
      return 'Shell V-Power';
    } else if (lubricantesFuel.includes(itemName)) {
      return 'Lubricantes y Combustibles';
    } else if (fuel.includes(itemName)) {
      return 'Combustibles';
    } else if (allProducts.includes(itemName)) {
      return 'Todos los productos';
    } else {
      return '';
    }
  }  

  getBenefitIcon(itemName: string): string {
    const icons: { [key: string]: string } = {
      'jumbo-15': '../../../assets/icon/icon-jumbo-mas.png',
      'personal-pay-20':'../../../assets/icon/icon-personal-pay.png',
      'ripio-5': '../../../assets/icon/icon-ripio.png',
      'prex-20': '../../../assets/icon/icon-prex.svg',
      '365-10': '../../../assets/icon/icon-clarin.jpg',
      '365-20': '../../../assets/icon/icon-clarin.jpg',
      'jumbo-vea-10': '../../../assets/icon/icon-jumbo-vea-cencosud.png',
      'club-easy-10': '../../../assets/icon/icon-club-easy.jpg',
      'galiciamas10': '../../../assets/icon/icon-galicia-mas.png',
      'galiciamaspremium15': '../../../assets/icon/icon-galicia-mas-premium.png',
      'eminent15': '../../../assets/icon/icon-eminent.png',
      'bna12': '../../../assets/icon/icon-BNA.jpg',
      'bnamodo-25': '../../../assets/icon/icon-modo-BNA.png',
      'jumbo15lubricantes': '../../../assets/icon/icon-jumbo-vea.png',
      'galicia10': '../../../assets/icon/icon-galicia.png',
    };
  
    return icons[itemName] || '';
  }  
  
  getTypeImage(categoryName: string): string {
    switch (categoryName) {
      case 'Lubricantes':
      case 'Combustibles':
      case 'Lubricantes y Combustibles':
        return '../../../assets/icon/icon-lubricant.svg';
      case 'Shell Select':
        return '../../../assets/icon/icon-shell-select.svg';
      case 'Shell V-Power':
        return '../../../assets/icon/icon-shell-v-power.svg';
      default:
        return '';
    }
  }  
  
  isActiveDay(day: number): boolean {
    return this.activeDays.includes(day);
  }

  categoryNameUrl(name: string | undefined): string {
    return (
      name
        ?.toLowerCase()
        .replace(/ /g, '-')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') || ''
    );
  }

  transformText(input: string): string {
    if (!input) return '';
    if (input.toLowerCase() === 'hot sale') {
      return 'Hot Sale';
    }
    const [firstWord, ...rest] = input.split(' ');
    const restOfText = rest.join(' ').toLowerCase();
    return (
      firstWord.charAt(0).toUpperCase() +
      firstWord.slice(1).toLowerCase() +
      (restOfText ? ` ${restOfText}` : '')
    );
  }

  getBenefitTypeImage(type: string): string {
    return type === 'PRESENCIAL' ? 'assets/icon/icon-in-person.svg' : 'assets/icon/icon-online.svg';
  }

  navigate(item: string, name: string){
    const url = `/beneficios-y-descuentos/${this.categoryNameUrl(item)}/${name}`;
    window.location.href = url;
  }
}
